// extracted by mini-css-extract-plugin
export default {"title":"Detail-module__title--371f","header":"Detail-module__header--8989","actionEdit":"Detail-module__actionEdit--c52d","inputTitle":"Detail-module__inputTitle--914c"};